import React from 'react'
import PropTypes from 'prop-types'
import { FeatureList } from 'components/molecules'

const Staff = ({ staff }) => (
  <FeatureList itemList={ staff } listClass={ 'list-checkmark' } />
)

Staff.propTypes = {
  staff: PropTypes.arrayOf(
    PropTypes.shape({
      items: PropTypes.arrayOf(PropTypes.string),
    })
  ),
}

export default Staff
